<template>
  <div :class="['home', { bgstyle: showMain }]">
    <HeadNav />
    <div id="main">
      <div :class="['content', { homeBgStyle: showMain }]">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import HeadNav from '../components/common/headNav.vue'
export default {
  name: 'home',
  components: {
    HeadNav,
  },
  data () {
    return {
      showMain: false
    };
  },
  watch: {
    $route: {
      handler (val) {
        console.log(val);
        if (val.path == "/") {
          this.showMain = true;
          this.$store.commit('updateBackStatus', false)
        } else {
          this.showMain = false;
          this.$store.commit('updateBackStatus', true)
        }
      }
    }
  },
  created () {
    this.$router.push({name:'Certificate'})
    if (this.$route.path == "/") {
      this.showMain = true;
      this.$store.commit('updateBackStatus', false)
    } else {
      this.showMain = false;
      this.$store.commit('updateBackStatus', true)
    }
    // 页面挂载获取表格高度启动vuex
    this.$store.commit('updateTableHeight')
    // 监听窗口resize事件 动态修改表格高度
    window.addEventListener('resize', () => {
      this.$store.commit('updateTableHeight')
    })
  }
}

</script>
<style lang='scss'>
.home {
  min-width: 1500px;
  width: 100%;
  height: 100%;
  background-color: #f7fbff;
  overflow-y: hidden;
  #main {
    width: calc(100% - 200px);
    height: calc(100% - 75px);
    min-width: 1500px;
    margin: 15px auto 0 auto;
    background-color: transparent;
    overflow: auto;
    .content {
      width: calc(100% - 286px);
      min-width: 1500px;
      // height: calc(100% - 75px);
      margin: 0px auto 0 auto;
    }
    .homeBgStyle {
      background: transparent;
    }
    > div {
      background-color: #fff;
    }
  }
}
.container {
  position: relative;
  padding: 0 20px;
  width: 100%;
  height: calc(100% - 50px);
  // background-color: lemonchiffon;
  overflow: hidden;
}
</style>